import { gql } from '@apollo/client';

export const GET_EPIC_SKILL_STATUS = gql`
  query GetEpicSkillStatus($input: getEpicSkillStatus) {
    getEpicSkillStatus(input: $input) {
      id
      projectId
      epicId
      skillId
      status
    }
  }
`;

export const ADD_DEPENDENCY = gql`
mutation AddDependency($input: DependencyEpicInput) {
  addDependency(input: $input) {
    message
    data {
      dependsOn
      epicId
      id
    }
  }
}
`;

export const DELETE_DEPENDENCY = gql`
mutation DeleteDependency($input: DeleteDependencyInput) {
  deleteDependency(input: $input) {
    message
    type
  }
}
`;

export const DELETE_EPIC = gql`
mutation DeleteEpic($input: DeleteEpicInput) {
  deleteEpic(input: $input) {
    type
    message
  }
}
`;

export const ADD_EPIC = gql`
mutation AddEpic($input: AddEpicInput) {
  addEpic(input: $input) {
    id
    epicId
    summary
  }
}
`;

export const GET_EPICS = gql`
query Epics(
  $projectId: ID!
  $order: [OrderInput]
  $isActive: Boolean!
  $ProjectSkillUsersProjectId: Int!
  $input: getEpicSkill
) {
  epics(projectId: $projectId, order: $order, isActive: $isActive) {
    epics {
      id
      epicId
      summary
      description
      sequence
      status
      isActive
      dependencies {
        id
        depends {
          id
          epicId
          summary
          description
        }
      }
    }
  }
  getProjectSkillUsers(projectId: $ProjectSkillUsersProjectId) {
    skill {
      id
      name
    }
  }
  getEpicSkill(input: $input) {
    id
    projectId
    skillId
    epicId
    duration
    team_members
  }
}
`;

export const UPDATE_SEQUENCE = gql`
mutation UpdateSequence($input: UpdateSequenceInput) {
  updateSequence(input: $input) {
    message
    type
  }
}
`;

export const UPDATE_EPIC = gql`
mutation UpdateEpic($input: UpdateEpicInput) {
  updateEpic(input: $input) {
    message
    type
  }
}
`;

export const UPDATE_EPIC_SKILL = gql`
mutation UpdateEpicSkill($input: UpdateEpicSkillInput) {
  updateEpicSkill(input: $input) {
    message
    type
  }
}
`;

export const UPDATE_SKILL_STATUS = gql`
mutation UpdateEpicSkillStatus($input: UpdateEpicSkillStatusInput) {
  updateEpicSkillStatus(input: $input) {
    message
    type
  }
}
`;
